import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.LOGIN_SUCCESS:
    case actionTypes.LOGOUT_ERROR:
      return Object.assign({}, state, action.payload);
    case actionTypes.LOGIN_ERROR:
    case actionTypes.LOGOUT_SUCCESS:
      return action.payload;
    case actionTypes.SHOW_LOADER:
      switch (action.payload) {
        case actionTypes.LOGIN:
          return Object.assign({}, state, { isLoginLoading: true });
        case actionTypes.LOGOUT:
          return Object.assign({}, state, { isLogoutLoading: true });
        case actionTypes.CHANGE_PASSWORD:
          return Object.assign({}, state, { isChangePasswordLoading: true });
        case actionTypes.FORGOT_PASSWORD:
          return Object.assign({}, state, { isForgotPasswordLoading: true });
        case actionTypes.NEW_PASSWORD:
          return Object.assign({}, state, { isNewPasswordLoading: true });
        default:
          return Object.assign({}, state);
      }
    case actionTypes.HIDE_LOADER:
      switch (action.payload) {
        case actionTypes.LOGIN:
          return Object.assign({}, state, { isLoginLoading: false });
        case actionTypes.LOGOUT:
          return Object.assign({}, state, { isLogoutLoading: false });
        case actionTypes.CHANGE_PASSWORD:
          return Object.assign({}, state, { isChangePasswordLoading: false });
        case actionTypes.FORGOT_PASSWORD:
          return Object.assign({}, state, { isForgotPasswordLoading: false });
        case actionTypes.NEW_PASSWORD:
          return Object.assign({}, state, { isNewPasswordLoading: false });
        default:
          return Object.assign({}, state);
      }
    default:
      return state;
  }
}
